var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 30,
    rx: 4.5,
    fill: "#CD2A3F",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.99 12.87H10.05V15.31H13.56V16.17H10.05V19H9.05V12H13.99V12.87ZM18.5795 19.08C16.4295 19.08 14.8495 17.55 14.8495 15.5C14.8495 13.45 16.4295 11.92 18.5795 11.92C20.7095 11.92 22.2895 13.44 22.2895 15.5C22.2895 17.56 20.7095 19.08 18.5795 19.08ZM18.5795 18.19C20.1295 18.19 21.2895 17.05 21.2895 15.5C21.2895 13.95 20.1295 12.81 18.5795 12.81C17.0095 12.81 15.8495 13.95 15.8495 15.5C15.8495 17.05 17.0095 18.19 18.5795 18.19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceOn);
export default __webpack_public_path__ + "static/media/FaceOn.6d2ed0e4c4d269ffdae50822d896a9c6.svg";
export { ForwardRef as ReactComponent };